import set from 'lodash/set';

const isArray = array => Array.isArray(array);
const isObject = value => typeof value === 'object' && !isArray(value);

function omitByDeep(obj, iteratee = v => !!v) {
  if (!isObject(obj)) return obj;

  const keys = Object.keys(obj);

  const cleanObj = keys.reduce((accum, key) => {
    let value = obj[key];

    if (isArray(value)) value = value.map(nestValue => omitByDeep(nestValue, iteratee));
    if (isObject(value)) value = omitByDeep(value, iteratee);

    if (iteratee(value)) set(accum, key, value);

    return accum;
  }, {});

  return cleanObj;
}

const validateRfcType = (rfc) => {
  if (rfc.length === 12) {
    return 'isEmployer';
  }

  if (rfc.length === 13) {
    return 'isIndividual';
  }

  return '';
};

const arrayToOptions = array => array.map(
  ({ key, value }) => ({
    value: key,
    label: `${key} - ${value}`,
  }),
);

const arrayToOptionsFilterByRFC = (array, rfc) => {
  array = arrayToOptions(
    array.filter(
      ({ isIndividualType, isEmployerType, active }) => (
        (validateRfcType(rfc) === 'isIndividual' ? isIndividualType : isEmployerType)
        && active
      ),
    ),
  );

  return array;
};

const helpers = {
  omitByDeep,
  arrayToOptionsFilterByRFC,
};

export default helpers;
